import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Use only for HTML content produced by the ui-rich-text component (Quill editor).
 * Quill restricts output to its allowed formats list, making it safe to bypass
 * Angular's sanitizer (which strips inline styles like color).
 */
@Pipe({ name: 'trustedHtml' })
export class TrustedHtmlPipe implements PipeTransform {
    constructor(private _sanitizer: DomSanitizer) {}

    transform(value: string): SafeHtml {
        return this._sanitizer.bypassSecurityTrustHtml(value ?? '');
    }
}
